<template>
  <div>
    <BaseModal :visible="visible" title="Booking Enquiry"
      wrapClassName="largerBookingModalWrap" @cancel="close" @ok="handleSubmit" :ok-loading="confirmLoading"
      :width="600">
      <form id="largerBookingForm" ref="largerBookingForm" method="post" novalidate @submit.prevent="handleSubmit">
        <div class="grid-col">
          <div class="formCol">
            <div class="input-group input-with-icon">
              <img src="/static/images/avatar_icon.svg" class="input-icon" alt="" />
              <input class="form-control input-with-padding" placeholder="First Name"
                v-model="largerBookForm.first_name" type="text" name="first_name" required />
            </div>
          </div>

          <div class="formCol">
            <div class="input-group input-with-icon">
              <img src="/static/images/avatar_icon.svg" class="input-icon" alt="" />
              <input class="form-control input-with-padding" placeholder="Last Name"
                v-model="largerBookForm.last_name" type="text" name="last_name" required />
            </div>
          </div>
        </div>

        <div class="formCol">
          <div class="input-group input-with-icon">
            <img src="/static/images/calendar_icon.svg" class="input-icon" alt="" />
            <input class="form-control input-with-padding date-input" placeholder="Date"
              :value="selectedDateText" type="text" readonly @click="showDatePicker" />
          </div>
        </div>

        <div class="grid-col">
          <div class="formCol">
            <div class="input-group input-with-icon">
              <img src="/static/images/team_icon.svg" class="input-icon" alt="" />
              <a-select class="form-control select-input custom-a-select" v-model="largerBookForm.covers"
                dropdownClassName="larger-booking-dropdown"
                placeholder="Party Size">
                <a-select-option v-for="(item, index) in coversSelectArr" :key="index" :value="item">
                  {{ item }}<span v-if="item == 1"> guest</span><span v-else> guests</span>
                </a-select-option>
              </a-select>
            </div>
          </div>

          <div class="formCol">
            <div class="input-group input-with-icon">
              <img src="/static/images/clock_icon.svg" class="input-icon" alt="" />
              <a-select class="form-control select-input custom-a-select" v-model="largerBookForm.time"
                dropdownClassName="larger-booking-dropdown"
                placeholder="Time">
                <a-select-option v-for="(item, index) in timeSelectArr" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </div>
          </div>
        </div>
        
        <div class="formCol">
          <div class="phoneNumberCol">
            <div class="country-dropdown-wrapper" id="mobile_areaCode">
              <a-select
                show-search
                optionLabelProp="label"
                dropdownClassName="larger-booking-dropdown area-code-dropdown"
                class="form-control select-input custom-a-select area-code-select"
                :value="`${country}|${areaCode}`"
                :filter-option="filterAreaCode"
                @change="onAreaCodeChange"
              >
                <a-select-option v-for="(item, index) in areaCodes" :key="index" :value="`${item.country}|${item.code}`" :label="`${item.country} ${item.code}`">
                  {{ item.label }}
                </a-select-option>
              </a-select>
            </div>
            <input v-model="areaCode" type="hidden" id="area_code" name="area_code" />
            <div class="input-group input-with-icon">
              <img src="/static/images/phone_icon.svg" class="input-icon" alt="" />
              <input class="form-control input-with-padding" placeholder="Phone Number" v-model="largerBookForm.phone"
                type="tel" name="phone" @input="handlePhoneInput" maxlength="15" required />
            </div>
          </div>
        </div>

        <div class="formCol">
          <div class="input-group input-with-icon">
            <img src="/static/images/email_icon.svg" class="input-icon" alt="" />
            <input class="form-control input-with-padding" placeholder="Email Address" v-model="largerBookForm.email"
              type="email" name="email" required />
          </div>
        </div>

        <div class="formCol">
          <div class="input-group">
            <textarea class="form-control customerNote"
              placeholder="If you have any special requests, leave a message here" v-model="largerBookForm.remark"
              rows="4" name="remark"></textarea>
          </div>
        </div>
      </form>
    </BaseModal>

    <BaseModal
      :visible="datePickerVisible"
      title="Choose a Date"
      wrapClassName="bookingEnquiryDateModalWrap"
      :width="420"
      :show-footer="false"
      :maskClosable="true"
      :z-index="1200"
      @cancel="closeDatePicker"
    >
      <div class="booking-enquiry-calendar">
        <div id="dateSelect-calendar1"></div>
      </div>
    </BaseModal>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment";
import "../../static/plugins/fullcalendar/dist/fullcalendar";
import "../../static/plugins/fullcalendar/dist/localeAll";
import "../../static/plugins/fullcalendar/dist/gcal";
import BaseModal from '@/components/BaseModal.vue';
import { areaCodes } from '@/utils/countryCode.js';

export default {
  name: 'BookingEnquiryModal',
  components: {
    BaseModal
  },
  props: {
    dateFormat: {
      type: String,
      default: 'DD MMM YYYY'
    },
    coversSelectArr: {
      type: Array,
      default: () => []
    },
    timeSelectArr: {
      type: Array,
      default: () => []
    },
    country: {
      type: String,
      default: 'UK'
    },
    areaCode: {
      type: String,
      default: '+44'
    },
    confirmLoading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      areaCodes,
      visible: false,
      datePickerVisible: false,
      largerBookForm: {
        first_name: "",
        last_name: "",
        covers: undefined,
        time: undefined,
        phone: "",
        email: "",
        remark: "",
        date: null,
        areaCode: ""
      }
    };
  },
  computed: {
    selectedDateText() {
      if (!this.largerBookForm.date) {
        return '';
      }

      return moment(this.largerBookForm.date, 'YYYY-MM-DD').format(this.dateFormat);
    }
  },
  methods: {
    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    },
    validateForm() {
      const firstName = (this.largerBookForm.first_name || '').trim();
      const lastName = (this.largerBookForm.last_name || '').trim();
      const phone = (this.largerBookForm.phone || '').trim();
      const email = (this.largerBookForm.email || '').trim();

      if (!firstName) {
        return 'Please enter your first name';
      }

      if (!lastName) {
        return 'Please enter your last name';
      }

      if (!this.largerBookForm.date) {
        return 'Please choose a date';
      }

      if (!this.largerBookForm.covers) {
        return 'Please select party size';
      }

      if (!this.largerBookForm.time) {
        return 'Please select a time';
      }

      if (!phone) {
        return 'Please enter your phone number';
      }

      if (!email) {
        return 'Please enter your email address';
      }

      if (!this.isValidEmail(email)) {
        return 'Please enter a valid email address';
      }

      this.largerBookForm.first_name = firstName;
      this.largerBookForm.last_name = lastName;
      this.largerBookForm.phone = phone;
      this.largerBookForm.email = email;

      return '';
    },
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
      this.closeDatePicker();
      this.largerBookForm = {
        first_name: "",
        last_name: "",
        covers: undefined,
        time: undefined,
        phone: "",
        email: "",
        remark: "",
        date: null,
        areaCode: ""
      };
      if (this.$refs.largerBookingForm) {
        this.$refs.largerBookingForm.reset();
      }
    },
    closeDatePicker() {
      this.datePickerVisible = false;
      this.destroyDateCalendar();
    },
    handlePhoneInput(e) {
      e.target.value = e.target.value.replace(/[^\d]/g, '');
      this.largerBookForm.phone = e.target.value;
    },
    showDatePicker() {
      this.datePickerVisible = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.renderDateCalendar();
        }, 60);
      });
    },
    filterAreaCode(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    onAreaCodeChange(val) {
      const [country, code] = val.split('|');
      this.$emit('getAreaCode', code, country);
    },
    destroyDateCalendar() {
      try {
        $('#dateSelect-calendar1').fullCalendar('destroy');
      } catch (error) {}
    },
    syncCalendarCellLayout($calendar) {
      $calendar.find('.fc-row.fc-week.fc-widget-content').each(function () {
        const rowHeight = $(this).height();
        $(this)
          .find('.fc-content-skeleton, .fc-content-skeleton table, .fc-content-skeleton td')
          .height(rowHeight);
        $(this).find('.fc-day-number').css('height', rowHeight - 4);
        $(this).find('.fc-day-number').css('line-height', `${rowHeight - 4}px`);
      });
      $calendar.find('.fc-content-skeleton').find('tbody *').empty().remove();
    },
    markSelectedDate($calendar) {
      if (!this.largerBookForm.date) {
        return;
      }

      $calendar.find('.fc-day-top.canAdd').each((index, element) => {
        const $day = $(element);
        if ($day.data('date') === this.largerBookForm.date) {
          $day.find('.fc-day-number').addClass('selected-date');
        }
      });
    },
    renderDateCalendar() {
      const self = this;
      const $calendar = $('#dateSelect-calendar1');

      this.destroyDateCalendar();

      $calendar.fullCalendar({
        header: {
          left: 'title',
          right: 'prev,next today',
          center: ''
        },
        buttonIcons: {
          prev: ' ti-angle-left',
          next: ' ti-angle-right'
        },
        firstDay: 1,
        selectable: false,
        selectHelper: false,
        editable: false,
        eventLimit: false,
        defaultView: 'month',
        defaultDate: this.largerBookForm.date || moment().format('YYYY-MM-DD'),
        fixedWeekCount: false,
        dayHeaderFormat: 'dd',
        dayNamesShort: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
        viewRender(view, element, currentView) {
          const activeView = currentView || view;
          const minDate = moment().format('YYYY-MM-DD');
          const maxDate = moment().add(1, 'year').format('YYYY-MM-DD');

          $calendar.find('.fc-day-top').each(function () {
            const $day = $(this);

            $day.removeClass('canAdd cannotAdd');
            if ($day.data('date') > maxDate || $day.data('date') < minDate) {
              $day.addClass('cannotAdd');
            } else {
              $day.addClass('canAdd');
            }
          });

          if (
            moment() >= activeView.start &&
            moment() <= activeView.end
          ) {
            $calendar.find('.fc-prev-button').prop('disabled', true);
            $calendar.find('.fc-prev-button').addClass('fc-state-disabled');
          } else {
            $calendar.find('.fc-prev-button').removeClass('fc-state-disabled');
            $calendar.find('.fc-prev-button').prop('disabled', false);
          }

          if (
            moment().add(1, 'year') >= activeView.start &&
            moment().add(1, 'year') <= activeView.end
          ) {
            $calendar.find('.fc-next-button').prop('disabled', true);
            $calendar.find('.fc-next-button').addClass('fc-state-disabled');
          } else {
            $calendar.find('.fc-next-button').removeClass('fc-state-disabled');
            $calendar.find('.fc-next-button').prop('disabled', false);
          }

          self.syncCalendarCellLayout($calendar);
          self.markSelectedDate($calendar);
        },
        navLinks: true,
        navLinkDayClick(date, jsEvent) {
          const reservationDate = date.format('YYYY-MM-DD');
          const $target = $(jsEvent.currentTarget);

          if ($target.parent('.fc-day-top').hasClass('canAdd')) {
            if (
              date >= moment().startOf('day') &&
              date <= moment().add(1, 'year')
            ) {
              self.largerBookForm.date = reservationDate;
              $calendar.find('a').removeClass('selected-date');
              $target.addClass('selected-date');
              self.closeDatePicker();
            } else {
              self.$emit(
                'error',
                'The selected date is unavailable, please choose another date.'
              );
            }
          } else {
            self.$emit(
              'error',
              'The selected date is unavailable, please choose another date.'
            );
          }
        }
      });

      $calendar.find('.fc-today-button').html('<i class="ti-world"></i>');
      this.syncCalendarCellLayout($calendar);
      this.markSelectedDate($calendar);
    },
    handleSubmit() {
      const errorMessage = this.validateForm();
      if (errorMessage) {
        this.$emit('error', errorMessage);
        return false;
      }
      
      this.$emit('submit', this.largerBookForm);
    }
  },
  beforeDestroy() {
    this.destroyDateCalendar();
  }
};
</script>

<style lang="scss">
.largerBookingModalWrap {
  .formCol {
    .input-group {
      margin-bottom: 20px;
    }
    
    .input-icon {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      color: #ccc;
      font-size: 18px;
      z-index: 10;
      pointer-events: none;
      width: 18px;
      height: 18px;
    }

    input.form-control,
    select.form-control,
    textarea.form-control {
      padding-left: 35px;
      line-height: 1.5;
      border-radius: 8px !important;
      // box-shadow: 2px 2px 2px rgba(5, 5, 5, 0.05);
      border-color: #f6f6f6;
      background-color: #f6f6f6 !important;
    }

    input.form-control,
    select.form-control {
      height: 50px;
      line-height: 50px;
      padding-top: 0;
      padding-bottom: 0;
    }

    /* 针对使用 a-select 的样式穿透覆盖 */
    .custom-a-select {
      width: 100%;
      height: 50px;
      border: none !important;
      background-color: transparent !important;
      padding-left: 0;
    }

    .custom-a-select .ant-select-selection {
      height: 50px;
      padding-left: 25px; /* 这里使用 25px(基于组件的11px额外自带padding) 加起来大致 35px 留给外部绝对定位图标 */
      border-radius: 8px !important;
      border-color: #f6f6f6;
      background-color: #f6f6f6 !important;
      box-shadow: none !important; /* 避免focus时出现原生阴影 */
    }

    .custom-a-select .ant-select-selection__rendered {
      line-height: 48px;
    }
    
    .custom-a-select .ant-select-arrow {
      right: 12px;
    }

    .area-code-select.custom-a-select .ant-select-selection {
      padding-left: 10px; /* 区号下拉没有图标，所以不需要留出图标空位 */
      // box-shadow: 2px 2px 5px rgba(5, 5, 5, 0.1), 2px 2px 2px rgba(5, 5, 5, 0.05) !important;
    }

    textarea.form-control {
      padding-left: 15px !important;
      padding-top: 10px;
      padding-bottom: 10px;
      resize: vertical;
    }
  }

  .grid-col {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  .phoneNumberCol {
    position: relative;
    display: grid;
    grid-template-columns: 110px calc(100% - 120px);
    // grid-template-columns: 2fr 3fr;
    grid-auto-flow: dense;
    grid-column-gap: 10px;

    .dropdown {
      height: 100%;

      .btn {
        width: 100%;
        height: 50px;
        background-color: #f6f6f6 !important;
        border: 1px solid #f6f6f6;
        border-radius: 8px;
        text-align: left;
        padding: 0 12px;
        font-size: 14px;
        color: #495057;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // box-shadow: 2px 2px 2px rgba(5, 5, 5, .05);
      }

      .btn::after {
        content: "";
        display: inline-block;
        width: 0;
        height: 0;
        margin-left: auto;
        vertical-align: middle;
        border-top: 5px solid;
        border-right: 5px solid transparent;
        border-left: 5px solid transparent;
        opacity: 0.5;
      }
      
      .btn:hover,
      .btn:focus {
        background-color: #fff;
        border-color: #d0d0d0;
        outline: 0;
      }
    }
  }
}
</style>

<style>
/* 控制 Booking Enquiry 下拉菜单里的 option 尺寸 */
.larger-booking-dropdown .ant-select-dropdown-menu-item {
  min-height: 46px !important;
  padding: 10px 14px !important;
  font-size: 14px !important;
  line-height: 1.45 !important;
  display: flex;
  align-items: center;
}

/* 单独将区号选择的下拉框放大，设置明确的宽度覆盖内联样式 */
.area-code-dropdown {
  width: 320px !important;
  min-width: 320px !important;
  max-width: calc(100vw - 32px);
}

.bookingEnquiryDateModalWrap .ant-modal {
  max-width: calc(100vw - 24px);
}

.bookingEnquiryDateModalWrap .ant-modal-body {
  padding: 20px !important;
}

.bookingEnquiryDateModalWrap .base-modal-content {
  text-align: left;
}

.booking-enquiry-calendar {
  min-height: 360px;
}

.booking-enquiry-calendar #dateSelect-calendar1 {
  margin-top: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/BookingEnquiryModal.vue